import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { error } from 'jquery';
import { Subscription, interval, startWith, switchMap } from 'rxjs';
import { ApiService } from 'src/app/services/api-service/api.service';
import { TokenStorageService } from 'src/app/services/token-storage-service/token-storage.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  sidebarStyle = 'sidebar-expanded';
  isLoggedIn = false;
  user: any;
  riparianParkingSubscriptionCount: number = 0;
  homeParkingSubscriptionParkingCount: number = 0;
  sidebarCollapsed = false;
  private parkingCountsSubscription: Subscription | undefined;

  constructor(
    public router: Router,
    private tokenStorageService: TokenStorageService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.tokenStorageService.getToken() !== '';

    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();

      setTimeout(() => {
        this.getParkingCounts();
      }, 500);
    }
  }

  public toggleSidebar(): void {
    this.sidebarStyle =
      this.sidebarStyle === 'sidebar-expanded'
        ? 'sidebar-collapsed'
        : 'sidebar-expanded';
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  public logout(): void {
    this.tokenStorageService.signOut();
  }

  getParkingCounts() {
    if (this.parkingCountsSubscription) {
      this.parkingCountsSubscription.unsubscribe();
    }

    this.parkingCountsSubscription = interval(15000)
      .pipe(
        startWith(0),
        switchMap(() => this.apiService.getParkingSubscriptionRequestCount())
      )
      .subscribe(
        (data: any) => {
          this.riparianParkingSubscriptionCount = data.riparian || 0;
          this.homeParkingSubscriptionParkingCount = data.home || 0;
        },
        (error: any) => {
          console.error('Error fetching parking counts', error);
        }
      );
  }
}
